<template>
  <div v-show="isVisible" class="launch-options" @click="onClickOptions">
    <div
      ref="optionItems"
      class="launch-options__items"
      :style="{ top: `${top}px`, left: `${numberCalculatedLeft}px` }"
    >
      <div
        v-for="(objectItem, index) of arrayItems"
        :key="index"
        class="launch-options__items__item"
        :class="{ disabled: getIsDisabled(objectItem) }"
        @click="onClickOption(objectItem)"
      >
        {{ objectItem.stringText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerLaunchOptions',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      arrayItems: [
        {
          numberId: 1,
          stringText: 'Home',
        },
        {
          numberId: 2,
          stringText: 'Analista',
        },
        {
          numberId: 3,
          stringText: 'Pantalla completa',
        },
      ],
    };
  },
  computed: {
    numberCalculatedLeft() {
      return this.left - 137;
    },
  },
  methods: {
    getIsDisabled(objectItem) {
      return this.$route.name === 'landingV2' && objectItem.numberId === 1;
    },
    onClickOption(objectItem) {
      if (this.getIsDisabled(objectItem)) {
        return;
      }
      switch (objectItem.numberId) {
        case 1:
          this.$router.push({ name: 'landingV2' });
          break;
        case 2:
          this.$emit('click-analyst');
          break;
        case 3:
          this.$emit('click-fullscreen');
          break;
        default:
          break;
      }
    },
    onClickOptions() {
      this.$emit('update:isVisible', false);
    },
  },
};
</script>

<style scoped lang="scss">
.launch-options {
  font-size: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;

  &__items {
    position: fixed;
    color: white;
    font-family: Avenir-Medium, sans-serif;
    font-size: 0.8125rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.77;
    letter-spacing: 0.29px;
    text-align: left;
    background-color: #132739;
    box-shadow: 0 16px 32px 0 rgba(20, 22, 41, 0.39);
    border-radius: 5px;

    &__item {
      padding: 0.75rem 0.875rem;
      cursor: pointer;

      &:hover {
        background-color: #4a88ff;
      }

      &.disabled {
        cursor: default;
        opacity: 0.5;

        &:hover {
          background-color: #132739;
        }
      }
    }
  }
}
</style>
